import { EnumDexBuySellOpts, IDexBuySellBotOptsUnit, IDexBuySellBotTypeUnit } from 'types/bots';

export const mapDexBuySellTaskType = (type: IDexBuySellBotTypeUnit): IDexBuySellBotOptsUnit => {
  if (type === '1w-ns') return EnumDexBuySellOpts.OPT_TYPE_1W_NS;

  if (type === '1w-1s') return EnumDexBuySellOpts.OPT_TYPE_1W_1S;

  return EnumDexBuySellOpts.OPT_TYPE_1W_NS;
};
